<template>
  <internal-process
    class="add-fund-to-series-container"
    @go-back="backHandler"
    :process-name="processTitle"
    :with-main-background="withMainBackground"
    :with-footer-background="withFooterBackground"
  >
    <component
      v-bind:is="currentComponent"
      :class="classContainer"
      :componentData="componentData"
      @component-action="componentActionHandler"
      @continue="continueHandler"
    ></component>
    <modal />
  </internal-process>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { config } from '@/config/add-fund-to-series-steps.json';

import SeriesStepperMixin from '@/mixins/SeriesStepperMixin';
import Modal from '@/components/atoms/Modal';
import SeriesListSelection from '@/components/organisms/SeriesListSelection';
import CreateNewSeries from '@/components/organisms/CreateNewSeries';
import SeriesFundsFinalSelection from '@/components/organisms/SeriesFundsFinalSelection';
import EditSeriesName from '@/components/organisms/EditSeriesName';

export default {
  name: 'add-fund-to-series',
  components: {
    'series-list-selection': SeriesListSelection,
    'create-new-series': CreateNewSeries,
    'series-funds-final-selection': SeriesFundsFinalSelection,
    'edit-series-name': EditSeriesName,
    Modal,
  },
  mixins: [
    SeriesStepperMixin(config),
  ],
  props: {
    fundSlug: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedSeries: null,
    };
  },
  async created() {
    if (!this.hasSelectedFund()) {
      await this.$router.push({
        name: 'notFound',
      });
      return false;
    }
    this.componentData = {
      ...this.componentData,
      selectedSeries: this.selectedSeries,
      selectedFund: this.selectedFund,
      selectedClient: this.selectedFund.selectedClient,
    };
    return this.componentData;
  },
  methods: {
    ...mapActions([
      'logError',
      'setIsLoading',
      'setSelectedFundToBeAdded',
      'openNotification',
      'cleanSelectedFundsList',
    ]),
    componentActionHandler(event) {
      if (event.name === 'go-to-create-new-series') {
        this.currentStep = this.getStepById('create-series');
      } else if (event.name === 'go-to-edit-series-name') {
        this.currentStep = this.getStepById('edit-series-name');
      } else if (event.name === 'selected-series-and-continue') {
        this.selectedSeries = event.selectedSeries;
        this.setSelectedSeries(event.name);
      } else if (event.name === 'selected-new-series-pending') {
        this.selectedSeries = event.newSeries;
        this.setSelectedSeries(event.name);
        this.continueHandler();
      } else if (event.name === 'edited-series-name-pending') {
        this.selectedSeries = event.editedSeries;
        this.setSelectedSeries(event.name);
        this.continueHandler();
      } else {
        this.currentStep = this.getStepById('series-selection');
      }
      return event.name;
    },
    setSelectedSeries(eventName) {
      this.componentData = {
        ...this.componentData,
        selectedSeries: this.selectedSeries,
      };

      if (eventName !== 'selected-series-and-continue') {
        this.openNotification({
          title: 'The changes has been saved',
          tinted: true,
        });
      }
    },
    hasSelectedFund() {
      return this.selectedFund && this.selectedFund.slug === this.fundSlug;
    },
  },
  computed: {
    ...mapState({
      selectedFund: (state) => state.grid.series.selectedFundToBeAdded,
    }),
  },
  beforeDestroy() {
    this.setSelectedFundToBeAdded(null);
    this.cleanSelectedFundsList();
  },
};
</script>

<style lang="scss" scoped>

</style>>
